import styled, { css } from "styled-components";

import color from "../_style/color";

const tagProps = {
  theme: {
    "outline-primary": css`
      border: 1px solid ${color.primary};
      color: ${color.primary};
    `,
    veryLightGrey: css`
      background-color: ${color.veryLightGrey};
      color: ${color.highempahis};
      border-radius: 0px;
    `,
    grey: css`
      background-color: ${color.dimgray};
      color: ${color.light};
      font-weight: 700;
    `,
    dark: css`
      background-color: ${color.nightRider};
      color: ${color.light};
      font-weight: 700;
    `,
    default: css`
      border: 1px solid ${color.gainsboro};
    `,
  },
  size: {
    xs: css`
      padding: 2px 5px;
      font-size: 11px;
      line-height: 1;
    `,
    s: css`
      padding: 1px 5px;
      font-size: 12px;
    `,
    m: css`
      padding: 0 6px;
      font-size: 12.5px;
      line-height: 20px;
    `,
    l: css`
      padding: 0 8px;
      font-size: 14px;
      line-height: 25px;
    `,
  },
};

const tagColorByType = { up: color.primary, down: color.primary, neutral: color.midgray };

const Tag = styled.div.attrs((props) => ({
  size: props.size || "m",
  type: props.type || "default",
  margin: props.margin || 0,
}))`
  ${({ type }) => tagProps.theme[type]}
  ${({ size }) => tagProps.size[size]}
  margin: ${({ margin }) => margin};
  font-family: "ProximaNovaRg";
  border-radius: 2px;
  display: inline-block;
  text-align: center;
`;

const SymbolTag = styled.div.attrs((props) => ({ type: props.type || "neutral" }))`
  display: inline-block;
  background-color: ${color.highempahis};
  text-align: center;
  height: 30px;
  padding: 0 10px;
  border-left: 5px solid;
  border-left-color: ${({ type }) => tagColorByType[type]};
  animation-duration: 0.6s;
  animation-fill-mode: both;
  animation-timing-function: ease-out;
  font-weight: bolder;
  font-size: 18px;
  line-height: 30px;
  color: ${color.light};
`;

export default { Tag, SymbolTag };
